import { ReportsRequest, ExportReportsRequest } from 'client/features/reports/actions'
import { fork, put } from 'redux-saga/effects'
import RequestSagas from 'client/core/RequestSagas'
import URLS from 'constant/URLS'
import { browserHistory } from 'react-router'
import { flash } from 'client/features/flashes/actions'

/*Fetch reports*/
export const getReportsSaga = new RequestSagas(ReportsRequest.get, { method: 'GET', endpoint: URLS.reports.get })
getReportsSaga.success = function* (action) {
    
}
getReportsSaga.failure = function* (action) {
    
}

/*Update reports*/
export const putReportsSaga = new RequestSagas(ReportsRequest.put, { method: 'PUT', endpoint: URLS.reports.get })
putReportsSaga.success = function* (action) {
    yield put(ReportsRequest.get.action())
}
putReportsSaga.failure = function* (action) {
    
}

/*Delete reports*/
export const deleteReportsSaga = new RequestSagas(ReportsRequest.delete, { method: 'delete', endpoint: URLS.reports.get })
deleteReportsSaga.success = function* (action) {
    yield put(flash({ content: {
        type: 'success',
        title: 'Rapport supprimé.'
    } }))
    yield put(ReportsRequest.get.action())

}
deleteReportsSaga.failure = function* (action) {
    
}


/*Fetch export*/
export const getExportReportsSaga = new RequestSagas(ExportReportsRequest.get, { method: 'GET', endpoint: URLS.reports.export })
getExportReportsSaga.success = function* (action) {
    
}


/*Export watchers sagas*/
const sagas = [
    fork(getReportsSaga.saga),
    fork(putReportsSaga.saga),
    fork(getExportReportsSaga.saga),
    fork(deleteReportsSaga.saga)
]

export default sagas


// WEBPACK FOOTER //
// ./src/client/features/reports/sagas.js